// In-memory handshake: the list view stamps a taskId after acquiring the CM
// lock so the form's mount effect can skip a redundant lock call. On reload /
// direct-URL nav / HMR the stamp is absent and the form locks itself. TTL
// bounds stale stamps from missed handshakes.

const STAMP_TTL_MS = 5_000

let recentlyLockedTaskId: string | null = null
let expirationTimeout: ReturnType<typeof setTimeout> | null = null

function clearStamp(): void {
  recentlyLockedTaskId = null
  if (expirationTimeout) {
    clearTimeout(expirationTimeout)
    expirationTimeout = null
  }
}

export function markLockJustAcquired(taskId: string): void {
  clearStamp()
  recentlyLockedTaskId = taskId
  expirationTimeout = setTimeout(clearStamp, STAMP_TTL_MS)
}

export function consumeLockJustAcquired(taskId: string): boolean {
  if (recentlyLockedTaskId === taskId) {
    clearStamp()
    return true
  }
  return false
}
